import { CalculateFieldNames } from 'utils/constants/fieldNames';
import { ChartFormOtherInfo } from 'interfaces/store/chartForms';
import { ISubmitData } from 'hooks/useSubmitData';
import { FieldValues } from 'interfaces/constants/CalculateModalConfig';

export const buildLocalData = (
  fieldsValues: FieldValues,
  otherInfo: ChartFormOtherInfo
): ISubmitData<string> => {
  return {
    currentARR: fieldsValues[CalculateFieldNames.CURRENT_ARR],
    revenue: fieldsValues[CalculateFieldNames.ANNUAL_REVENUE],
    yoyARR: fieldsValues[CalculateFieldNames.YOY_ARR],
    fcfMargin: fieldsValues[CalculateFieldNames.FCF_MARGIN],
    avgDealSize: fieldsValues[CalculateFieldNames.AVG_DEAL_SIZE],
    totalHeadcount: fieldsValues[CalculateFieldNames.TOTAL_HEADCOUNT],
    grossMargin: fieldsValues[CalculateFieldNames.GROSS_MARGIN],
    arrPerFTE: fieldsValues[CalculateFieldNames.ARR_PER_FTE],
    ruleOf40: fieldsValues[CalculateFieldNames.RULE_OF_40],
    newLogoARR: fieldsValues[CalculateFieldNames.NEW_LOGO_ARR],
    expansionARR: fieldsValues[CalculateFieldNames.EXPANSION_ARR],
    newLogoArrOfGrossNew:
      fieldsValues[CalculateFieldNames.NEW_LOGO_ARR_OF_GROSS_NEW],
    expansionArrOfGrossNew:
      fieldsValues[CalculateFieldNames.EXPANSION_ARR_OF_GROSS_NEW],
    quickRatio: fieldsValues[CalculateFieldNames.QUICK_RATIO],
    netDollarRetention: fieldsValues[CalculateFieldNames.NET_DOLLAR_RETENTION],
    grossDollarRetention:
      fieldsValues[CalculateFieldNames.GROSS_DOLLAR_RETENTION],
    newLogoVelocity: fieldsValues[CalculateFieldNames.NEW_LOGO_VELOCITY],
    burnMultiple: fieldsValues[CalculateFieldNames.BURN_MULTIPLE],
    netMagicNumber: fieldsValues[CalculateFieldNames.NET_MAGIC_NUMBER],
    rD: fieldsValues[CalculateFieldNames.RD_ABSOLUTE_OPEX],
    gA: fieldsValues[CalculateFieldNames.GA_ABSOLUTE_OPEX],
    sM: fieldsValues[CalculateFieldNames.SM_ABSOLUTE_OPEX],
    rDPercent: fieldsValues[CalculateFieldNames.RD_PERCENT_OPEX],
    gAPercent: fieldsValues[CalculateFieldNames.GA_PERCENT_OPEX],
    sMPercent: fieldsValues[CalculateFieldNames.SM_PERCENT_OPEX],
    cacPayback: fieldsValues[CalculateFieldNames.CAC_PAYBACK_PERIOD],
    opexPerFTE: fieldsValues[CalculateFieldNames.OPEX_PER_FTE],
    rDHead: fieldsValues[CalculateFieldNames.RD_HEADCOUNT],
    gAHead: fieldsValues[CalculateFieldNames.GA_HEADCOUNT],
    sMHead: fieldsValues[CalculateFieldNames.SM_HEADCOUNT],
    rDHeadPercent: fieldsValues[CalculateFieldNames.RD_HEADCOUNT_PERCENT],
    gAHeadPercent: fieldsValues[CalculateFieldNames.GA_HEADCOUNT_PERCENT],
    sMHeadPercent: fieldsValues[CalculateFieldNames.SM_HEADCOUNT_PERCENT],
    grossChurnARR: fieldsValues[CalculateFieldNames.GROSS_CHURN_ARR],
    endPeriodARR: fieldsValues[CalculateFieldNames.EOP_ARR],
    beginPeriodARR: fieldsValues[CalculateFieldNames.BOP_ARR],
    netNewARR: fieldsValues[CalculateFieldNames.NET_NEW_ARR],
    sMOPEX: fieldsValues[CalculateFieldNames.SM_OPEX],
    totalOPEX: fieldsValues[CalculateFieldNames.TOTAL_OPEX],
    uuid: sessionStorage.getItem('uuid') || localStorage.getItem('uuid') || '',
    companyStatus: otherInfo.companyStatus,
    companyWebsite: otherInfo.companyWebsite,
    email: otherInfo.email,
    companyLogoURL: otherInfo.companyLogoURL,
    companyColor: otherInfo.companyColor
  };
};
